import { Plugin } from '@nuxt/types';

import { getChannelId } from '@root/libs/init-channel/utils/getChannelId';
import { channelConfigService } from '@root/modules/channel/services/channelConfig.service';
import { feedService } from '@root/modules/frontpage/services/feed.service';

const saveInitialData: Plugin = async (ctx) => {
  const initialDataExists = Boolean(ctx.store.getters['getStorage']('channelConfig') && ctx.store.getters['getStorage']('channelConfig'));
  if (initialDataExists) {
    return;
  }

  if (process.server) {
    const req: PortalRootIncomingMessage = ctx.req;
    const channelConfig = req.channelConfig;
    const frontPageFeed = req.frontPageFeed;

    ctx.store.commit('setStorage', { channelConfig });
    ctx.store.commit('frontpage/setTempData', frontPageFeed);

    return;
  }

  if (process.client) {
    const channelId = getChannelId();
    const channelConfig = await channelConfigService.fetch(channelId);
    ctx.store.commit('setStorage', { channelConfig });

    const frontPageFeed = (await feedService.fetch(channelId))?.feed;
    ctx.store.commit('frontpage/setTempData', frontPageFeed);
  }
};

export default saveInitialData;
